import React from 'react'
import './fleetMilesByZip.module.scss'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

interface IFleetMilesByZipDashboardProps {
  print?: boolean
  useCarrierFilters: boolean
}

const FleetMilesByZipDashboard: React.FC<IFleetMilesByZipDashboardProps> = (
  props
) => {
  const { useCarrierFilters } = props
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgent = isAgentLogin()
  const isCarrier = isCarrierLogin()

  const invitingCompanyId =
    isCarrier || isAgent ? ensuredInvitingCompanyId : undefined
  const carrierId =
    useCarrierFilters && !isCarrier
      ? localStorage.getItem('carrierId') || undefined
      : undefined
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.MILES_BY_ZIP}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
    />
  )
}

export default FleetMilesByZipDashboard
